export const gid_status_tr = {
  "IDEA": "Fikir",
  "IN_PROGRESS": "Devam Eden",
  "WAITING_FOR_DEVELOPMENT": "Geliştirilmeyi Bekleyen",
  "DEAD": "Sonlandırılan",
  "DONE": "Tamamlanan",
};
